import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import TooltipFoodCertificate from './TooltipFoodCertificate'
import { foodCertificates } from 'config/constants';

const Items = ({items}) => {
    const pageContainer = useRef(null);

    const getContainerRef = () => {
        return pageContainer.current;
    };

    return (
        <>
            <div className="food-certificate-items-wrap" ref={pageContainer}>
                {items && items.map((item,i) => {
                    const elem = foodCertificates[item];
                    const menssage = `<h1 class="title-message-tooltip"><strong>${elem.title}</strong></h1> ${elem.description}`

                    return (
                        <div key={i} className="food-certificate-item">
                            <TooltipFoodCertificate message={menssage} getContainerRef={getContainerRef}>
                                <div className="food-certificate-info-wrap">
                                    <i className={"food-certificate-icon " + elem.icon}></i>
                                    <span className="food-certificate-text" dangerouslySetInnerHTML={{ __html: elem.titleHtml}}></span>
                                </div>
                            </TooltipFoodCertificate>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

Items.propTypes = {
    items: PropTypes.array
}

export default Items;